import React from 'react';
import { MapPin, Clock } from 'lucide-react';

interface VenueDetailsProps {
  venue: any;
  language: 'en' | 'mr';
}

export const VenueDetailsSection: React.FC<VenueDetailsProps> = ({ venue, language }) => {
  const venueName = language === 'mr' ? venue.venueMr : venue.venue;
  const dateStr = language === 'mr' ? venue.dateMr : venue.dateStr;

  return (
    <section className="relative py-24 px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-center text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400 mb-12">
          {language === 'mr' ? '📍 आयोजन विवरण' : '📍 Event Details'}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl blur opacity-75 group-hover:opacity-100 transition-all" />
            <div className="relative bg-slate-900 rounded-xl p-8 text-center border border-slate-800">
              <Clock className="w-8 h-8 mx-auto mb-4 text-blue-400" />
              <p className="text-gray-400 text-sm uppercase tracking-wider mb-2">
                {language === 'mr' ? 'तारीख' : 'Date'}
              </p>
              <p className="text-xl font-bold text-blue-300">{dateStr}</p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 to-purple-500 rounded-xl blur opacity-75 group-hover:opacity-100 transition-all" />
            <div className="relative bg-slate-900 rounded-xl p-8 text-center border border-slate-800">
              <MapPin className="w-8 h-8 mx-auto mb-4 text-pink-400" />
              <p className="text-gray-400 text-sm uppercase tracking-wider mb-2">
                {language === 'mr' ? 'स्थान' : 'Location'}
              </p>
              <p className="text-lg font-bold text-pink-300 line-clamp-2">{venueName}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
